<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Business Info') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-4 mb-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Contact Information') }}
                </v-card-title>

                <v-text-field
                  v-model="formData.business.email"
                  dense
                  outlined
                  :label="$t('Email')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.business.phone"
                  dense
                  outlined
                  :label="$t('Phone')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.business.name"
                  dense
                  outlined
                  :label="$t('Name')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.business.address"
                  dense
                  outlined
                  :label="$t('Address')"
                  @input="updateForm"
                />

                <v-checkbox
                  v-model="formData.show_whatsapp_link"
                  hide-details
                  @change="updateForm"
                >
                  <template #label>
                    <div class="d-flex align-center">
                      <v-icon left color="success">mdi-whatsapp</v-icon>
                      {{ $t('Show WhatsApp Link on booking site') }}
                    </div>
                  </template>
                </v-checkbox>

                <div class="text-caption grey--text my-2">
                  {{
                    $t(
                      'Messages will be sent to the CMS phone number (not necessarily the Business phone number shown above)'
                    )
                  }}
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined class="pa-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Social Links') }}
                </v-card-title>

                <v-text-field
                  v-model="formData.social_links.about_us"
                  dense
                  outlined
                  :label="$t('About Us')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.social_links.facebook"
                  dense
                  outlined
                  :label="$t('Facebook')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.social_links.instagram"
                  dense
                  outlined
                  :label="$t('Instagram')"
                  @input="updateForm"
                />

                <v-text-field
                  v-model="formData.social_links.google"
                  dense
                  outlined
                  :label="$t('Google')"
                  @input="updateForm"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'BusinessInfo',

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        business: this.bookingEngineSetting.business || {},
        social_links: this.bookingEngineSetting.social_links || {},
        show_whatsapp_link:
          this.bookingEngineSetting.show_whatsapp_link || false,
      },
    }
  },

  methods: {
    updateForm() {
      this.$emit('update:setting', this.formData)
    },
  },
}
</script>
